import { Chip } from '@mui/material';

const ESTADO_COLORS = {
  CREADA:                    { bg: '#DBEAFE', color: '#1E40AF' },
  OBSERVADA:                 { bg: '#FEF3C7', color: '#92400E' },
  ENVIADA_A_BODEGA:          { bg: '#E0E7FF', color: '#3730A3' },
  EN_PROCESO:                { bg: '#FEF9C3', color: '#854D0E' },
  PARCIALMENTE_ENCONTRADA:   { bg: '#FEF9C3', color: '#854D0E' },
  PARCIALMENTE_LISTA:        { bg: '#FEF9C3', color: '#854D0E' },
  TODOS_DOCUMENTOS_LISTOS:   { bg: '#D1FAE5', color: '#065F46' },
  PARCIALMENTE_DIGITALIZADA: { bg: '#FEF9C3', color: '#854D0E' },
  TODOS_DIGITALIZADOS:       { bg: '#D1FAE5', color: '#065F46' },
  MENSAJERO_SOLICITADO:      { bg: '#E0E7FF', color: '#3730A3' },
  MENSAJERO_ASIGNADO:        { bg: '#E0E7FF', color: '#3730A3' },
  ENVIADA_AL_CLIENTE:        { bg: '#DBEAFE', color: '#1E40AF' },
  ENTREGADA_AL_CLIENTE:      { bg: '#D1FAE5', color: '#065F46' },
  COMPARTIDA:                { bg: '#D1FAE5', color: '#065F46' },
  PENDIENTE_DEVOLUCION:      { bg: '#FEF3C7', color: '#92400E' },
  DEVUELTA_POR_CLIENTE:      { bg: '#E0E7FF', color: '#3730A3' },
  RECIBIDA:                  { bg: '#DBEAFE', color: '#1E40AF' },
  REENVIADA_A_BODEGA:        { bg: '#E0E7FF', color: '#3730A3' },
  REARCHIVADA:               { bg: '#D1FAE5', color: '#065F46' },
  CERRADA:                   { bg: '#F3F4F6', color: '#374151' },
  CANCELADA:                 { bg: '#FEE2E2', color: '#991B1B' },
  LISTA_PARA_ENVIO:          { bg: '#D1FAE5', color: '#065F46' },
  EN_RUTA:                   { bg: '#E0E7FF', color: '#3730A3' },
  // Return states
  SOLICITADA:                { bg: '#DBEAFE', color: '#1E40AF' },
  APROBADA:                  { bg: '#D1FAE5', color: '#065F46' },
  RECHAZADA:                 { bg: '#FEE2E2', color: '#991B1B' },
  // Transfer states
  PENDIENTE:                 { bg: '#FEF9C3', color: '#854D0E' },
  COMPLETADA:                { bg: '#D1FAE5', color: '#065F46' },
  // Document states
  ENCONTRADO:                { bg: '#D1FAE5', color: '#065F46' },
  NO_ENCONTRADO:             { bg: '#FEE2E2', color: '#991B1B' },
  ENTREGADO:                 { bg: '#D1FAE5', color: '#065F46' },
  DEVUELTO:                  { bg: '#E0E7FF', color: '#3730A3' },
};

const ESTADO_LABELS = {
  CREADA: 'Creada',
  OBSERVADA: 'Observada',
  ENVIADA_A_BODEGA: 'Enviada a bodega',
  EN_PROCESO: 'En proceso',
  PARCIALMENTE_ENCONTRADA: 'Parcialmente encontrada',
  PARCIALMENTE_LISTA: 'Parcialmente lista',
  TODOS_DOCUMENTOS_LISTOS: 'Todos listos',
  PARCIALMENTE_DIGITALIZADA: 'Parcialmente digitalizada',
  TODOS_DIGITALIZADOS: 'Todos digitalizados',
  MENSAJERO_SOLICITADO: 'Mensajero solicitado',
  MENSAJERO_ASIGNADO: 'Mensajero asignado',
  ENVIADA_AL_CLIENTE: 'Enviada al cliente',
  ENTREGADA_AL_CLIENTE: 'Entregada',
  COMPARTIDA: 'Compartida',
  PENDIENTE_DEVOLUCION: 'Pendiente devolucion',
  DEVUELTA_POR_CLIENTE: 'Devuelta por cliente',
  RECIBIDA: 'Recibida',
  REENVIADA_A_BODEGA: 'Reenviada a bodega',
  REARCHIVADA: 'Rearchivada',
  CERRADA: 'Cerrada',
  CANCELADA: 'Cancelada',
  LISTA_PARA_ENVIO: 'Lista para envio',
  EN_RUTA: 'En ruta',
  SOLICITADA: 'Solicitada',
  APROBADA: 'Aprobada',
  RECHAZADA: 'Rechazada',
  PENDIENTE: 'Pendiente',
  COMPLETADA: 'Completada',
  ENCONTRADO: 'Encontrado',
  NO_ENCONTRADO: 'No encontrado',
  ENTREGADO: 'Entregado',
  DEVUELTO: 'Devuelto',
};

const EstadoChip = ({ estado, size = 'small' }) => {
  const colors = ESTADO_COLORS[estado] || { bg: '#F3F4F6', color: '#374151' };
  return (
    <Chip
      label={ESTADO_LABELS[estado] || estado}
      size={size}
      sx={{
        bgcolor: colors.bg,
        color: colors.color,
        fontWeight: 600,
        fontSize: '0.75rem',
        borderRadius: 0,
      }}
    />
  );
};

export default EstadoChip;
